import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import withServices from '../hocs/withServices';

function AuthorizedRoute({ services, component: Component, ...rest }) {
  return <Route
    {...rest}
    render={props =>
      services.auth.isLoggedIn() ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: props.location }
          }}
        />
      )
    }
  />;
}

export default withServices()(AuthorizedRoute);